import type { DailyTag } from "@/pages/human-resources/time-management/business/daily-tag/DailyTag";
import {
  buildCommonParts,
  type PrintCommonParts,
} from "@/pages/human-resources/time-management/endpoints/schedules/print/inout/CommonParts";
import type { DisplayOptions } from "@/pages/human-resources/time-management/model/display-options/DisplayOptions";
import { legacyFormatFrenchDate } from "@/shared/utils/LegacyDates";
import {
  mapFromArrangementAndOrder,
  type PrintArrangementIn,
} from "@/pages/human-resources/time-management/endpoints/schedules/print/inout/PrintArrangementIn.ts";
import type { ScheduleViewFilters } from "@/pages/human-resources/time-management/components/display-filters/provider/ScheduleViewFilters.ts";

export interface PrintDailyScheduleIn extends PrintCommonParts {
  dateDebut: string; // uses format: dd/MM/yyyy
  dateFin: string; // uses format: dd/MM/yyyy
  idSite: string;
  withFonction: boolean;
  withPauses: boolean;
  withPostes: boolean;
  withSautPage: boolean;
  arrangement: PrintArrangementIn;
}

export function inputForPrintDailySchedule(
  startDate: Date,
  endDate: Date,
  siteId: string,
  employeesIds: string[],
  visibleDailyTags: DailyTag[],
  displayOptions: DisplayOptions,
  viewFilters: ScheduleViewFilters,
): PrintDailyScheduleIn {
  return {
    ...buildCommonParts(employeesIds, visibleDailyTags, displayOptions),
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    dateDebut: legacyFormatFrenchDate(startDate),
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    dateFin: legacyFormatFrenchDate(endDate),
    idSite: siteId,
    withFonction: true,
    withPauses: displayOptions.showBreaks,
    withPostes: displayOptions.showPositions,
    withSautPage: true,
    arrangement: mapFromArrangementAndOrder(
      viewFilters.viewArrangement,
      viewFilters.employeesOrder,
    ),
  };
}
